import CONFIG from '../config/config';
import { instanceWithV2 as APIClient } from './SimpleAPIClient';

export type CustomerCrmAutomationSettings = {
  automationEnabled: boolean;
  autoClosedOnSaleLinked: boolean;
  autoVisitOnFirstMeeting: boolean;
};

const CustomersCrmAutomationAPI = {
  get: () =>
    APIClient(CONFIG.API_ENDPOINT).get<CustomerCrmAutomationSettings>('/v1/customersCrm/automation-settings'),
  save: (body: CustomerCrmAutomationSettings) =>
    APIClient(CONFIG.API_ENDPOINT).put<CustomerCrmAutomationSettings>('/v1/customersCrm/automation-settings', body),
};

export default CustomersCrmAutomationAPI;
